// @ts-ignore
import enCoreTranslations from 'ckeditor5/translations/en.js'
// @ts-ignore
import enPremiumFeaturesTranslations from 'ckeditor5-premium-features/translations/en.js'

import { Bold, Italic, LegacyList } from '../plugins/core'
// [IMPORTANT] - This data is injected during build time by build.ts as we need this static data in both UI and CS
import Placeholders from './Placeholders.json'

export const ToolbarConfig = {
  toolbar: {
    items: [
      'heading',
      'importNotesTemplate',
      '|',
      'bold',
      'italic',
      'underline',
      'link',
      'bulletedList',
      'numberedList',
      'todoList',
      '|',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'insertTable',
      'imageUpload',
      'undo',
      'redo',
      'comment',
      'trackChanges',
      '|',
      'revisionHistory',
      'placeholder',
    ],
  },
}

export const ImageConfig = {
  image: {
    toolbar: [
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
      '|',
      'toggleImageCaption',
      'imageTextAlternative',
      '|',
      'linkImage',
    ],
  },
}

export const CommentsConfig = {
  comments: {
    editorConfig: {
      extraPlugins: [Bold, Italic, LegacyList],
    },
  },
}

export const PlaceholderConfig = {
  placeholderConfig: { types: Placeholders },
}

export const TranslationsConfig = {
  translations: [enCoreTranslations, enPremiumFeaturesTranslations],
}
